import React from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import { useTranslation } from 'react-i18next'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { FaPrescriptionBottle } from 'react-icons/fa6'
import PageHeader from '../../shared/PageHeader'

export const DEFAULT_PRESCRIPTION_SETTINGS = {
  items: true,
  diagnosis: true,
  vital_signs: true
}

const DISPLAY_CONTROLS = [
  ['items', 'Show items', 'Include prescription medications and items'],
  ['diagnosis', 'Show diagnosis', "Include the patient's diagnosis"],
  ['vital_signs', 'Show vital signs', "Include the patient's vital signs"]
]

export function PrescriptionSettings ({ embedded = false, settings, updateSettings, updateLoading }) {
  const { t, i18n } = useTranslation()
  const setting = settings?.invoice_size
  const prescription = { ...DEFAULT_PRESCRIPTION_SETTINGS, ...(setting?.prescription_settings || {}) }
  const change = values => updateSettings({ ...setting, prescription_settings: { ...prescription, ...values } })

  if (!setting?.id) {
    return <section className='rounded-xl border bg-white p-5 text-sm text-gray-500'>{t('Prescription settings are not available')}</section>
  }

  const content = <section className='overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
    <div className='border-b border-gray-200 bg-gray-50 px-5 py-4'>
      <h2 className='flex items-center gap-2 text-base font-semibold text-gray-800'>
        <FaPrescriptionBottle className='text-primary' />
        {t('Prescription Settings')}
      </h2>
      <p className='mt-1 text-sm text-gray-500'>{t('Configure which sections are displayed on prescriptions')}</p>
    </div>
    <div className='p-5'>
      {DISPLAY_CONTROLS.map(([key, label, description]) => <div key={key} className='flex items-center justify-between border-b py-4 last:border-b-0'>
        <div className='space-y-0.5'>
          <label className='block text-sm font-medium text-gray-800'>{t(label)}</label>
          <p className='text-xs text-gray-500'>{t(description)}</p>
        </div>
        <div className='flex items-center gap-3'>
          <span className='text-sm text-gray-600'>{prescription[key] ? t('Enabled') : t('Disabled')}</span>
          <InputSwitch checked={prescription[key]} onChange={e => change({ [key]: e.value })} disabled={updateLoading} />
        </div>
      </div>)}
    </div>
  </section>

  if (embedded) return content
  return <div className='main-page-container !overflow-y-auto scrollbar'><PageHeader title={t('Prescription Settings')} Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight} />{content}</div>
}

export default PrescriptionSettings
